const config = {
  ssoConfig: {
    redirect_uri: "https://wifi-guest.helpline.fr/authorize_return",
    authorization: "https://login.microsoftonline.com/e1ffe413-68d6-4603-bb4e-7e95c2f0f58d/oauth2/v2.0/authorize",
    client_id: "93004ab0-01f8-4dad-97aa-df2927dff1a0",
    protocol: "OAuthPKCE",
    token: "https://login.microsoftonline.com/e1ffe413-68d6-4603-bb4e-7e95c2f0f58d/oauth2/v2.0/token",
    scope: "openid profile email api://93004ab0-01f8-4dad-97aa-df2927dff1a0/wifi-guest",
    response_type: "code",
    response_mode: "query",
    grant_type: "authorization_code",
  },
};
module.exports = config;
